import React from 'react';
import DriverListView from '../collectingcenter/DriverListView';
import CashierListView from './CashierListView';
import AdminCCDetailView from './AdminCCDetailView';
import MechineSettingView from './MechineSettingView';
import { CarOutlined, DesktopOutlined, ShopOutlined, UserOutlined } from '@ant-design/icons';
import { useWindowDimensionContext } from '../../hooks/WindowDimensionProvider';
import { useTranslation } from 'react-i18next';
import URLTabs from '../common/URLTabs';


export default function AdminView() {
    const { lessThanOrEqual } = useWindowDimensionContext();
    const isOnMobile = lessThanOrEqual('md');
    const { t, i18n } = useTranslation();


    return(
      <div>
        {!isOnMobile ? (
          <URLTabs
            defaultActiveKey='#detail'
            items={[
              {key: "#detail", label: <span><ShopOutlined />{t("menu.collecting_center")}</span>, children:<AdminCCDetailView/> },
              // {key: "#machine", label: <span><DesktopOutlined />เครื่องให้บริการ</span>, children:<MechineSettingView/> },
              {key: "#cashier", label: <span><UserOutlined />{t("profiles.username")}</span>, children: <CashierListView />},
              {key: "#driver", label: <span><CarOutlined />{t("driver")}</span>, children: <DriverListView />},
            ]}
          />
        ) : (
          <AdminCCDetailView/>
        )}
      </div>
    )} 